/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTheme } from '@mui/system';
import { selectSnackbar } from 'cart-ui-react/src/autoshipState/selectors';

// imported to initialize hook
import useCloseSnack from './useCloseSnack';

const Mobile = () => {
  const theme = useTheme();
  const closeSnack = useCloseSnack();
  const { message, type } = useSelector(selectSnackbar);
  const open = useMemo(() => Boolean(message && type), [message, type]);

  const getColor = () => {
    switch (type) {
      case 'error':
        return theme.palette.error.main;
      case 'warning':
        return theme.palette.warning.main;
      case 'success':
      default:
        return theme.palette.success.main;
    }
  };

  const Icon = () => {
    switch (type) {
      case 'warning':
        return <WarningAmberIcon fontSize='large' />;
      case 'error':
        return <ErrorOutlineIcon fontSize='large' />;
      case 'success':
      default:
        return <CheckCircleOutlineIcon fontSize='large' />;
    }
  };

  return (
    <Slide direction='down' in={open} mountOnEnter unmountOnExit>
      <Box
        sx={{
          width: '100vw',
          position: 'fixed',
          color: 'white',
          background: getColor(),
          zIndex: 55,
          minHeight: '40px',
          height: 'fit-content',
          top: 0,
          left: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
          p: 1,
        }}
      >
        <Icon />
        <Typography
          gutterBottom
          sx={{ flexGrow: 1, fontSize: '18px' }}
          textAlign='center'
        >
          {message}
        </Typography>
      </Box>
    </Slide>
  );
};

export default Mobile;
